import React from 'react'
import { FiCheck } from 'react-icons/fi'

interface AutoSaveIndicatorProps {
  isSaving: boolean
  lastSaved?: Date | null
}

export const AutoSaveIndicator: React.FC<AutoSaveIndicatorProps> = ({
  isSaving,
  lastSaved
}) => {
  if (isSaving) {
    return (
      <div className="fixed bottom-4 right-4 bg-white border border-gray-200 rounded-md px-3 py-2 shadow-md z-[1000]">
        <div className="flex items-center gap-2">
          <div className="animate-spin rounded-full h-4 w-4 border-2 border-brand-500 border-t-transparent" />
          <span className="text-sm text-gray-600">Saving...</span>
        </div>
      </div>
    )
  }

  if (lastSaved) {
    return (
      <div className="fixed bottom-4 right-4 bg-white border border-green-200 rounded-md px-3 py-2 shadow-md z-[1000]">
        <div className="flex items-center gap-2">
          <FiCheck className="text-green-500 w-4 h-4" />
          <span className="text-sm text-gray-600">Saved</span>
        </div>
      </div>
    )
  }

  return null
}







